import { CustomFacet, CustomFacetValue, RangeFacet } from '@catalog/const';
import { Action } from '@ngrx/store';

export const TOGGLE_SELECTED_FACET = '[Search] Search Toggle Selected Facet';
export const SET_SELECTED_FACET_VALUE = '[Search] Search Set Selected Facet Value';
export const SET_SELECTED_FACET_RANGE_VALUE = '[Search] Search Set Selected Facet Range Value';
export const CLEAR_SELECTED_FACETS = '[Search] Clear Selected Facet Values';

export class ToggleSelectedFacet implements Action {
  readonly type = TOGGLE_SELECTED_FACET;

  constructor(public payload: { facet: CustomFacet; value: CustomFacetValue; force?: boolean }) {}
}

export class SetSelectedFacetValue implements Action {
  readonly type = SET_SELECTED_FACET_VALUE;

  constructor(public payload: { facet: CustomFacet; value: number | string | boolean }) {}
}

export class SetSelectedFacetRangeValue implements Action {
  readonly type = SET_SELECTED_FACET_RANGE_VALUE;

  constructor(public payload: { facet: RangeFacet; value: (number | null)[] }) {}
}

export class ClearSelectedFacets implements Action {
  readonly type = CLEAR_SELECTED_FACETS;

  constructor() {}
}

export type SearchSelectedFacetsAction =
  | ToggleSelectedFacet
  | SetSelectedFacetValue
  | SetSelectedFacetRangeValue
  | ClearSelectedFacets;
